import ContactModel             from './ContactModel';

export default class ContactWithGlobalContactModel extends ContactModel {

	static get path(): string {
		return '/contacts/_with_global_contact';
	}

}
